export default __webpack_public_path__ + "static/media/folder.aa74ad58.svg";